import React from "react";
import * as Image from '../../../Assets/Images'
import './style.css'

const ThankYouCard = ({status,label}) => {
    return (
      <div className="thankyou-card">
        <img src={Image.congratulations}/>
        <div>
          <img src={Image.thankyou_policy}/>
          <label>{label}</label>
        </div>
      </div>
    )
}

export default ThankYouCard